import React from 'react';

export interface ErpFormTextProps extends React.HTMLAttributes<HTMLElement> {
  inline?: boolean;
}

export const ErpFormText: React.FC<ErpFormTextProps> = ({
  inline,
  children,
  className,
  ...props
}) => {
  return (
    <small {...props} className={['text-[0.8rem] text-slate-500 mt-1 block', inline && 'inline', className].filter(Boolean).join(' ')}>
      {children}
    </small>
  );
};
